"use client";

import { css, styled } from "styled-components";

import { poppins_body_md_semibold } from "@frontend/design-system";

export const Tab = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
`;

export const Chip = styled.button<{
  $isSelected: boolean;
  $isHover: boolean;
}>`
  display: flex;
  height: 3.2rem;
  padding: var(--Spacing-6, 0.6rem) var(--Spacing-12, 1.2rem);
  justify-content: center;
  align-items: center;
  gap: var(--Spacing-4, 0.4rem);
  color: var(--Color-Common-Text-Interactive-Secondary, #515c6c);
  text-align: center;
  ${poppins_body_md_semibold}
  cursor: pointer;
  border-bottom: 1px solid
    var(--Color-Common-Border-Interactive-Secondary, #b1b8c4);

  &:hover {
    color: var(--Color-Common-Text-Interactive-Primary-Hovered, #3d4551);
    border-bottom: 1px solid
      var(--Color-Common-Border-Interactive-Primary-Hovered, #96a1b0);
  }

  ${({ $isHover }) =>
    $isHover &&
    css`
      color: var(--Color-Common-Text-Interactive-Primary-Hovered, #017abc);
      border-bottom: 1px solid
        var(--Color-Common-Border-Interactive-Primary-Hovered, #017abc);
    `}

  &:active {
    color: var(--Color-Common-Text-Interactive-Secondary-Pressed, #2a2f37);
    border-bottom: 1px solid
      var(--Color-Common-Border-Interactive-Secondary-Pressed, #7c899c);
  }

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      color: var(--Color-Common-Text-Interactive-Selected, #0198e9);
      border-bottom: 2px solid
        var(--Color-Common-Border-Interactive-Primary, #0198e9);

      &:hover {
        color: var(--Color-Common-Text-Interactive-Primary-Hovered, #017abc);
        border-bottom: 2px solid
          var(--Color-Common-Border-Interactive-Primary-Hovered, #017abc);
      }

      &:active {
        color: var(--Color-Common-Text-Interactive-Primary-Pressed, #015d8e);
        border-bottom: 2px solid
          var(--Color-Common-Border-Interactive-Primary-Pressed, #015d8e);
      }
    `}

  ${({ $isHover, $isSelected }) =>
    $isHover &&
    $isSelected &&
    css`
      color: var(--Color-Common-Text-Interactive-Primary-Pressed, #015d8e);
      border-bottom: 2px solid
        var(--Color-Common-Border-Interactive-Primary-Pressed, #015d8e);
    `}
`;
